export default __webpack_public_path__ + "static/config-2025-maturing-teams-header-35651f38629f9a065df9fa4dff6cc3c8d3932572d282c77214c10dff4ad265c9.png";